// extracted by mini-css-extract-plugin
export default {"wrappText":"ModalContactForm_wrappText__HOVaP","text":"ModalContactForm_text__6zuJE"};